<template>
    <div class="bus-list">

        <div class="cont">

            <div class="cont-up">

                <div class="item-title">招标投标</div>
                <div class="item-box">
                    <p class="box-title">支持招标投标法中规定的公开招标和邀请招标采购形式，包括交通、住建、水利、发改等各行业范本</p>
                    <div class="img-box">
                        <div v-for="(item,index) in tabs1" :key="index" :class="item.class">
                            <img :src="item.img" :alt="item.text">
                            <div>
                                <p class="title">{{item.text}}</p>
                                <p>{{item.text2}}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="item-title">政府采购</div>
                <div class="item-box">
                    <p class="box-title">支持政府采购法中规定的所有采购形式和规范</p>
                    <div class="item-zfcg">

                        <div class="left-box">
                            <div class="left-item" v-for="(item,i) in tabs2Item" :key="i">
                                <p class="bg-box">{{item.title}}</p>
                                <p :class="[ item.class ? 'boldClass' : '']">{{item.text}} </p>
                            </div>
                        </div>

                        <div class="right-box">
                            <div class="right-title">系统特点</div>
                            <div class="box-inner1" v-for="(item,index) in tabs2" :key="index">
                                {{item.text}}
                            </div>
                        </div>

                    </div>
                </div>

                <div class="item-other">
                    <div>
                        <img src="/images/products/bid-pro/pc.png" alt="">
                    </div>

                    <div class="boxs">
                        <div class="box-top">
                            <div v-for="(item,i) in 2" :key="i">
                            </div>
                        </div>
                        <div class="box-bot">
                            <div v-for="(item,i) in 4" :key="i">
                            </div>
                        </div>
                    </div>
                    <div class="card-list">
                        <div class="card-item" v-for="(item,i) in tabs3" :key="i">
                            <p class="title">{{ item.title }}</p>
                            <p>{{ item.text }}</p>
                        </div>
                    </div>
                </div>

            </div>

            <div class="cont-down">
                <div class="item-title">产品附加价值</div>
                <div class="mainbox">
                    <div class="img-box">
                        <div class="jz-box" v-for="(item,index) in tabs11" :key="index">
                            <img :src="item.img" :alt="item.text">
                            <p>{{item.text}}</p>
                            <span v-if="item.text2">{{item.text2}}</span>

                        </div>

                    </div>

                </div>
            </div>

        </div>

    </div>
</template>


<script>
export default {
    name: '',
    data() {
        return {
            tabs1: [
                {
                    img: '/images/products/bid-pro/yy-1.png',
                    text: '发改行业',
                    text2: '招投标范本',
                },
                {
                    img: '/images/products/bid-pro/yy-2.png',
                    text: '交通行业',
                    text2: '招投标范本',
                },
                {
                    img: '/images/products/bid-pro/yy-3.png',
                    text: '水利行业',
                    text2: '招投标范本',
                },
                {
                    img: '/images/products/bid-pro/yy-4.png',
                    text: '住建行业',
                    text2: '招投标范本',
                },
            ],
            tabs2: [
                { text: '可根据需求选择搭建，灵活组合，定制服务' },
                { text: '预留接口，可对接OA、财务等已有平台' },
                { text: '共享10000+行业专家资源，提供专业评标室' },
            ],
            tabs2Item: [
                { title: '公开招标', text: '招标人以招标公告的方式邀请不特定的法人或者其他组织投标' },
                { title: '邀请招标', text: '招标采购单位依法从符合相应资格条件的供应商中随机邀请三家以上供应商，并以投标邀请书的方式，邀请其参加投标' },
                { title: '竞争性谈判/磋商', text: '谈判小组从供应商名单中确定不少于三家的供应商参加谈判，并向其提供谈判文件的一种采购方式' },
                { title: '单一来源', text: '达到了限价标准和公开招标数额标准，但所购商品的来源渠道单一，或同专利不能从其他供应商处采购等情况' },
                { title: '询价采购', text: '从供应商名单中确定不少于三家的供应商向其发出询价单让其报价，然后询价小组进行比较，并确定最优供应商的一种采购方式' },
                {
                    title: '框架协议',
                    text: '第一阶段，采购人归集同类采购项目及其预计采购数量，通过招标、谈判、询比等方式竞争选择入围供应商名单，并以框架协议与入围供应商约定相关内容；第二阶段，采购人按照框架协议约定条件与入围供应商订立和履行采购合同',
                    class: 'true',
                },
            ],

            tabs3: [
                { title: '远程异地评标', text: '评审全程在线，数据全程共享，操作全程留痕' },
                { title: '资料自动归档', text: '交易产生的所有文件自动归档，在线保存，随时查阅，一键下载' },
                { title: '数字证书互认', text: '支持多种主流CA证书，跨省项目无需重复办理' },
                { title: '交易全程监督', text: '从建项到交易结束，全程实时查看（投标文件除外），可在关键节点下达监督命令' },
                { title: '数据&部署', text: '多项标准数据接口，且支持定制接口；支持数据导出到本地' },
            ],

            tabs11: [
                {
                    img: '/images/products/bid-pro/jz-1.png',
                    text: '20余年工程咨询',
                    text2: '15年互联网研发经验',
                },
                {
                    img: '/images/products/bid-pro/jz-2.png',
                    text: '10000+行业专家资源',
                },
                {
                    img: '/images/products/bid-pro/jz-3.png',
                    text: '享受免费培训',
                    text2: '多行业标书模版等服务',
                },
                {
                    img: '/images/products/bid-pro/jz-4.png',
                    text: '最新政策咨询解读',
                },
                {
                    img: '/images/products/bid-pro/jz-5.png',
                    text: '相关法律援助',
                },
            ],
        };
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.bus-list {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 100px;
    //外边小标题
    .item-title {
        font-size: 22px;
        margin: 30px 0 20px;
        font-weight: 600;
        text-align: center;
    }
    //内部小标题
    .box-title {
        margin-bottom: 30px;
        font-size: 20px;
        color: #7b7b7b;
        text-align: center;
    }
    //招标投标
    .item-box {
        width: 1200px;
        .img-box {
            display: flex;
            justify-content: space-between;
            & > div {
                width: 255px;
                height: 150px;
                background-color: #f2f7ff;
                display: flex;
                align-items: center;
                cursor: pointer;
                &:hover {
                    color: #8a1f94;
                }
                img {
                    height: 42px;
                    width: 42px;
                    margin-left: 40px;
                }
                p {
                    font-size: 16px;
                    margin-left: 35px;
                }
                .title {
                    font-size: 18px;
                    font-weight: 600;
                    margin-bottom: 5px;
                }
            }
        }
    }

    .font14 {
        font-size: 14px !important;
    }
    .jz-box {
        width: 237px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .img {
            width: 24px;
            height: 21px !important;
        }
    }

    //下部分
    .cont-down {
        background-color: #fff;
        .cont-item {
            border-bottom: 1px solid #ddd;
            .cont-item-inner {
                display: flex;
                justify-content: space-between;
                .cont-item-left,
                .cont-item-right {
                    width: 590px;
                }
            }
        }
    }
}
.cont {
    // 公共样式
    color: #131415;
    p {
        font-size: 16px;
        line-height: 25px;
    }

    //政府采购
    .item-zfcg {
        display: flex;
        height: 600px;
        margin-bottom: 20px;
        .left-box {
            width: 940px;
            height: 100%;
            background-color: #f9fbff;
            padding: 30px 20px;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            .bg-box {
                display: inline-block;
                background-color: #4f7bff;
                padding: 2px 10px;
                color: #fff;
                font-size: 14px;
                margin-bottom: 4px;
            }
            p {
                line-height: 30px;
            }
            .boldClass {
                font-weight: 600;
            }
        }
        .right-box {
            font-size: 16px;
            width: 260px;
            height: 100%;
            background-color: #edf3ff;
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            align-items: center;
            .right-title {
                position: absolute;
                top: 30px;
                font-size: 16px;
            }
            .box-inner1 {
                width: 210px;
                height: 95px;
                background-color: #fff;
                border-radius: 5px;
                font-weight: 600;
                padding: 20px 15px;
                cursor: pointer;
                &:hover{
                    color: #8a1f94;
                }
            }
        }
    }
    //其他
    .item-other {
        padding: 40px 0;
        text-align: center;
        .boxs {
            height: 60px;
            margin: 6px 0;
            .box-top {
                height: 20px;
                display: flex;
                justify-content: center;
                div {
                    width: 240px;
                    height: 20px;
                    &:nth-child(2) {
                        border-left: 1px solid #c4c4c4;
                        margin-left: -2px;
                    }
                }
            }

            .box-bot {
                display: flex;
                justify-content: center;
                height: 40px;
                div {
                    width: 240px;
                    height: 40px;
                    border: 1px solid #c4c4c4;
                    border-bottom: none;
                    &:nth-child(n + 2) {
                        border-left: none;
                    }
                }
            }
        }
        .card-list {
            text-align: left;
            display: flex;
            justify-content: space-between;
            .card-item {
                width: 230px;
                height: 145px;
                background-color: #ebf1ff;
                padding: 20px 15px;
                cursor: pointer;
                // &:hover{
                    // color: #8a1f94;
                // }
                p {
                    font-size: 14px;
                    font-weight: 600;
                }
                .title {
                    font-size: 16px;
                    font-weight: normal;
                }
                &:nth-child(2) {
                    background-color: #fff3eb;
                }
                &:nth-child(3) {
                    background-color: #f7efff;
                }
                &:nth-child(4) {
                    background-color: #def9f0;
                }
                &:nth-child(5) {
                    background-color: #e4f7ff;
                }
            }
        }
    }

    .mainbox {
        width: 100%;
        background-color: #fff;
        .img-box {
            margin-top: 15px;
            display: flex;
            justify-content: space-evenly;
        }
        .jz-box {
            width: 155px;
            height: 128px;
            text-align: center;
            position: relative;
            padding-top: 15px;
            display: flex;
            flex-direction: column;
            justify-content: center;

            p {
                text-align: center;
                margin-top: 10px;
                color: #2d2d2d;
                font-size: 14px !important;
            }

            &::after {
                content: '';
                display: inline-block;
                // 定义元素位置
                position: absolute;
                top: 32px;
                left: 177px;

                // 定义元素宽高
                width: 24px;
                height: 21px;
                background-image: url('/images/products/bid-pro/jz-jt.png');
                background-size: 100% 100%;
            }
            &:last-child::after {
                display: none;
            }
        }
    }
}
</style>
